import { PhonemeType } from "@/generated/graphql";

interface PhonemeTypeFilterProps {
  activeType: PhonemeType | null;
  onTypeChange: (type: PhonemeType | null) => void;
  typeCounts: Record<PhonemeType, number>;
}

const PHONEME_TYPE_OPTIONS: Array<{ value: PhonemeType; label: string }> = [
  { value: PhonemeType.Consonant, label: "Consonants" },
  { value: PhonemeType.ShortVowel, label: "Short Vowels" },
  { value: PhonemeType.LongVowel, label: "Long Vowels" },
  { value: PhonemeType.Digraph, label: "Digraphs" },
  { value: PhonemeType.Trigraph, label: "Trigraphs" },
  { value: PhonemeType.Blend, label: "Blends" },
  { value: PhonemeType.Diphthong, label: "Diphthongs" },
  { value: PhonemeType.RControlled, label: "R-Controlled" },
  { value: PhonemeType.VowelTeam, label: "Vowel Teams" },
  { value: PhonemeType.SilentLetter, label: "Silent Letters" },
  { value: PhonemeType.VariantVowel, label: "Variant Vowels" },
  { value: PhonemeType.Schwa, label: "Schwa" },
  { value: PhonemeType.SoftHard, label: "Soft/Hard" },
  { value: PhonemeType.SpecialPattern, label: "Special Patterns" },
  { value: PhonemeType.Other, label: "Other" },
];

export function PhonemeTypeFilter({
  activeType,
  onTypeChange,
  typeCounts,
}: PhonemeTypeFilterProps) {
  const totalCount = Object.values(typeCounts).reduce((sum, count) => sum + count, 0);

  return (
    <div className="mb-4">
      <div className="flex items-center gap-2 mb-2">
        <span className="text-xs font-medium text-slate-600">Filter:</span>
      </div>
      <div className="flex flex-wrap gap-1.5">
        <button
          type="button"
          onClick={() => onTypeChange(null)}
          className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-medium transition-colors ${
            activeType === null
              ? "bg-primary-600 text-white shadow-sm"
              : "bg-slate-100 text-slate-700 hover:bg-slate-200"
          }`}
        >
          All
          <span className="rounded-full bg-primary-500 px-1.5 py-0.5 text-[10px] font-semibold text-white">
            {totalCount}
          </span>
        </button>
        {PHONEME_TYPE_OPTIONS.map((option) => {
          const count = typeCounts[option.value] || 0;
          if (count === 0) return null;

          return (
            <button
              key={option.value}
              type="button"
              onClick={() => onTypeChange(option.value)}
              className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-medium transition-colors ${
                activeType === option.value
                  ? "bg-primary-600 text-white shadow-sm"
                  : "bg-slate-100 text-slate-700 hover:bg-slate-200"
              }`}
            >
              {option.label}
              <span
                className={`rounded-full px-1.5 py-0.5 text-[10px] font-semibold ${
                  activeType === option.value
                    ? "bg-primary-500 text-white"
                    : "bg-slate-200 text-slate-600"
                }`}
              >
                {count}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
